/* ============================================================================
   RK Set-Kauf

   Rechnet die Summe mit, leitet aus Titeln wie „0,5m French Terry …" die
   Gesamtlänge ab und legt am Ende alle angehakten Teile in einem Rutsch in
   den Warenkorb.
   ========================================================================= */
(function () {
  'use strict';

  function geld(cent) {
    return (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  /* Sucht im Produkttitel ein Maß wie „0,5m", „1 m" oder „0,5 Meter".
     Nur dann lässt sich aus der Stückzahl eine Länge ausrechnen. */
  function einheitAusTitel(titel) {
    var treffer = /(\d+(?:[.,]\d+)?)\s*(m|meter)\b/i.exec(titel || '');
    if (!treffer) return null;
    var zahl = parseFloat(treffer[1].replace(',', '.'));
    return isFinite(zahl) && zahl > 0 ? zahl : null;
  }

  function laengeText(einheit, anzahl) {
    var gesamt = einheit * anzahl;
    var text = gesamt.toLocaleString('de-DE', { maximumFractionDigits: 2 });
    return '= ' + text + ' m';
  }

  function start(wurzel) {
    var dialog = wurzel;
    var positionen = [].slice.call(dialog.querySelectorAll('[data-rk-set-pos]'));
    var summeFeld = dialog.querySelector('[data-rk-set-summe]');
    var kaufen = dialog.querySelector('[data-rk-set-kaufen]');
    var kaufenText = dialog.querySelector('[data-rk-set-kaufen-text]');
    var fehlerFeld = dialog.querySelector('[data-rk-set-fehler]');
    if (!positionen.length) return;

    function preisVon(pos) {
      var wahl = pos.querySelector('[data-rk-set-variante]');
      if (wahl && wahl.tagName === 'SELECT') {
        var opt = wahl.options[wahl.selectedIndex];
        if (opt && opt.dataset.preis) return parseInt(opt.dataset.preis, 10) || 0;
      }
      return parseInt(pos.dataset.preis, 10) || 0;
    }

    function rechne() {
      var summe = 0;
      var teile = 0;

      positionen.forEach(function (pos) {
        var an = pos.querySelector('[data-rk-set-an]');
        var anzahl = parseInt(pos.querySelector('[data-rk-set-anzahl]').value, 10) || 1;
        var massFeld = pos.querySelector('[data-rk-set-mass]');
        var einheit = einheitAusTitel(pos.dataset.produkt);

        massFeld.textContent = einheit ? laengeText(einheit, anzahl) : '';
        pos.classList.toggle('ist-aus', !an.checked);

        if (an.checked) {
          summe += preisVon(pos) * anzahl;
          teile += 1;
        }
      });

      summeFeld.textContent = teile ? geld(summe) : '—';
      kaufen.disabled = teile === 0;
      if (kaufenText) {
        kaufenText.textContent = teile > 1
          ? 'Set in den Warenkorb (' + teile + ' Teile)'
          : 'In den Warenkorb';
      }
    }

    // --- Bedienung ---------------------------------------------------------

    positionen.forEach(function (pos) {
      var feld = pos.querySelector('[data-rk-set-anzahl]');
      var an = pos.querySelector('[data-rk-set-an]');

      pos.querySelector('[data-rk-set-minus]').addEventListener('click', function () {
        feld.value = Math.max(1, (parseInt(feld.value, 10) || 1) - 1);
        rechne();
      });
      pos.querySelector('[data-rk-set-plus]').addEventListener('click', function () {
        feld.value = Math.min(99, (parseInt(feld.value, 10) || 1) + 1);
        rechne();
      });
      feld.addEventListener('input', rechne);
      an.addEventListener('change', rechne);

      var wahl = pos.querySelector('select[data-rk-set-variante]');
      if (wahl) wahl.addEventListener('change', rechne);
    });

    // --- In den Warenkorb --------------------------------------------------

    kaufen.addEventListener('click', function () {
      var posten = [];
      positionen.forEach(function (pos) {
        if (!pos.querySelector('[data-rk-set-an]').checked) return;
        var wahl = pos.querySelector('[data-rk-set-variante]');
        var id = wahl.tagName === 'SELECT' ? wahl.value : wahl.getAttribute('value');
        var anzahl = parseInt(pos.querySelector('[data-rk-set-anzahl]').value, 10) || 1;
        if (id) posten.push({ id: Number(id), quantity: anzahl });
      });
      if (!posten.length) return;

      kaufen.disabled = true;
      if (kaufenText) kaufenText.textContent = 'Wird hinzugefügt …';
      if (fehlerFeld) fehlerFeld.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: posten })
      })
        .then(function (a) { return a.json().then(function (d) { return { ok: a.ok, daten: d }; }); })
        .then(function (r) {
          if (!r.ok) throw new Error(r.daten && r.daten.description ? r.daten.description : 'Das hat nicht geklappt.');
          if (kaufenText) kaufenText.textContent = 'Im Warenkorb ✓';
          /* Das Theme lauscht darauf und frischt Warenkorb und Schublade auf. */
          document.dispatchEvent(new CustomEvent('rk:warenkorb-geaendert'));
          setTimeout(function () { window.location.href = '/cart'; }, 700);
        })
        .catch(function (f) {
          kaufen.disabled = false;
          if (kaufenText) kaufenText.textContent = 'Nochmal versuchen';
          if (fehlerFeld) {
            fehlerFeld.textContent = f.message || 'Das hat nicht geklappt.';
            fehlerFeld.hidden = false;
          }
        });
    });

    rechne();
  }

  function alle() {
    document.querySelectorAll('[data-rk-set]').forEach(function (d) {
      if (d.dataset.rkBereit) return;
      d.dataset.rkBereit = '1';
      start(d);
    });

    document.querySelectorAll('[data-rk-set-auf]').forEach(function (knopf) {
      if (knopf.dataset.rkBereit) return;
      knopf.dataset.rkBereit = '1';
      knopf.addEventListener('click', function () {
        var d = document.querySelector('[data-rk-set]');
        if (!d) return;
        if (typeof d.showModal === 'function') d.showModal();
        else d.setAttribute('open', '');     // sehr alte Browser
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  document.addEventListener('shopify:section:load', alle);
})();
